<template>
  <div class="purchase-history">
    <div class="purchase-history__heading">История покупок</div>
    <div v-if="loading" class="purchase-history__loader">
      <Loader size="24" />
    </div>
    <div v-if="!loading">
      <div class="purchase-history__items" v-if="items.length > 0">
        <PurchaseCard
          v-for="(item, i) in items"
          :key="i"
          :options="item"
          @how-to="onHowTo(i)"
        >
        </PurchaseCard>
      </div>
      <div class="purchase-history__empty" v-if="items.length === 0">
        <img :src="emptyRafiki" class="purchase-history__image" />
        <div class="purchase-history__text">У вас пока нет купленных товаров</div>
        <div class="purchase-history__subtext">Выберите на что потратить баллы среди множества товаров в разделе <Link variant="primary" @click="$router.push({ name: 'Market', query: this.isMobileApp ? { title: 'Маркет', addToHistory: 'true' } : {} }).catch(() => {})">«Маркет»</Link></div>
        <div class="purchase-history__button">
          <Button
            variant="primary"
            size="lg"
            text="Начать покупки"
            @click="onMarket"
            mobile
          ></Button>
        </div>
      </div>
    </div>

    <Modal
      name="reward-bought-details"
      title="Как получить товар?"
      subtitle="Ваш промокод для получения товара:"
      :active="boughtModal"
      :noTransition="true"
      :class="{ 'for-mobile-app': isMobileApp }"
      @close.prevent="onBoughtClosed"
    >
      <div class="reward-bought__promocode">
        <div class="reward-bought__promocode-item" v-for="(item, index) in promocodes" :key="index">{{ item }}</div>
      </div>
      <div class="reward-bought__message text-left" v-html="steps"></div>
    </Modal>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import PurchaseCard from './PurchaseCard.vue';

export default {
  name: 'PurchaseHistory',
  components: {
    PurchaseCard,
  },
  data() {
    return {
      items: [],
      boughtModal: false,
      code: '',
      promocodes: [],
      steps: '',
      loading: true,
    };
  },
  computed: {
    ...mapGetters('settings', ['resources']),
    ...mapGetters('operations', ['searchEventsData']),
    ...mapGetters('user', ['isMobileApp', 'profile']),
    emptyRafiki() {
      return this.resources ? this.resources.emptyRafiki || '' : '';
    },
  },
  methods: {
    ...mapActions('operations', ['searchEvents']),
    ...mapActions('user', ['getProfile']),
    onHashChange() {
      if (this.$route.name !== 'SettingsHistory') {
        window.removeEventListener('hashchange', this.onHashChange);
        return;
      }
      const hash = window.location.hash.split('=');
      if (hash[0] === '#!showBought') this.showBought(hash);
      else {
        this.clearHash();
        this.boughtModal = false;
      }
    },
    onHowTo(index) {
      if (!this.items) {
        this.code = '';
        this.steps = '';
        this.promocodes = [];
        return;
      }
      const item = this.items[index];
      this.code = item.code || '';
      this.steps = item.howToGet || '';
      const promocodesStr = item.promocodes || '';
      this.promocodes = promocodesStr ? promocodesStr.split(',').map((code) => code.trim()).filter((code) => code) : [];
      this.boughtModal = true;
      // Устанавливаем хеш только если operationId существует
      const { operationId } = item;
      if (operationId) {
        this.$root.$setLocationHash(`#!showBought=${this.items[index].operationId}`);
      }
    },
    onBoughtClosed() {
      this.$root.$setLocationHash('#!showBought=false');
    },
    onMarket() {
      this.$router.push({ name: 'Market', query: this.isMobileApp ? { title: 'Маркет', addToHistory: 'true' } : {} }).catch(() => {});
    },
    getMetadataValue(metadata, name) {
      const item = metadata.find((m) => m.name === name);
      return item ? item.value : null;
    },
    getOperationType(event) {
      const tag = event.tags.find((t) => t.key === 'OperationType');
      return tag ? tag.value : null;
    },
    convertEventToOperation(event) {
      const operationType = this.getOperationType(event);
      const attributes = {};
      event.metadata.forEach((meta) => {
        attributes[meta.name] = meta.value;
      });

      // Добавляем данные из objects (для заданий и других сущностей)
      if (event.objects && event.objects.length > 0) {
        event.objects.forEach((obj) => {
          if (obj.metadata) {
            obj.metadata.forEach((meta) => {
              // Добавляем, только если ещё нет в attributes
              if (!attributes[meta.name]) {
                attributes[meta.name] = meta.value;
              }
            });
          }
        });
      }

      return {
        operationId: event.eventId || event.operationId || null,
        operationType,
        operationDate: event.operationDate || event.eventDate,
        operationSourceId: this.getMetadataValue(event.metadata, 'OperationSourceId'),
        attributes,
        state: 'Synchronized',
      };
    },
    getMapppedOperations(operations) {
      if (!operations) return [];
      const items = [];
      for (let i = 0; i < operations.length; i += 1) {
        const value = operations[i];
        const item = this.getMappedItem(value);
        if (item && Object.keys(item).length > 0) {
          items.push(item);
        }
      }
      return items;
    },
    getMappedItem(value) {
      const item = {};
      if (value.operationType === 'Purchase') {
        item.operationId = value.operationId;
        item.img = value.attributes.ProductMobileImageUrl || '';
        item.title = value.attributes.ProductName || '';
        item.coins = Math.round(value.attributes.Amount || 0);
        item.date = value.operationDate;
        item.code = value.attributes.PromocodeCode || '';
        item.howToGet = value.attributes.ProductHowToGet || '';
        item.promocodes = value.attributes.Promocodes || '';
        return item;
      }
      return item;
    },
    showBought(hash) {
      if (hash[1] && hash[1] !== 'false') {
        const index = this.items.findIndex((i) => i.operationId === hash[1]);
        if (index >= 0) this.onHowTo(index);
      } else {
        this.boughtModal = false;
        this.clearHash();
      }
    },
    clearHash() {
      setTimeout(() => { this.$root.$setLocationHash(''); }, 100);
    },
  },
  mounted() {
    // Используем searchEvents для получения покупок, как в разделе активности
    this.getProfile().then(() => {
      if (this.profile && this.profile.participantId && this.profile.marketingProgramId) {
        this.searchEvents({
          subjectId: this.profile.participantId,
          tags: [],
          tagsQuery: '"OperationType"="Purchase"',
          offset: 0,
          count: 100,
        }).then(() => {
          if (this.searchEventsData && this.searchEventsData.values) {
            // Конвертируем события в операции
            const operations = this.searchEventsData.values.map((event) => this.convertEventToOperation(event));
            // Логируем для просмотра структуры данных
            this.items = this.getMapppedOperations(operations);
            this.loading = false;

            window.addEventListener('hashchange', this.onHashChange);
            this.onHashChange();
          } else {
            this.loading = false;
          }
        }).catch(() => {
          this.loading = false;
        });
      } else {
        this.loading = false;
      }
    });
  },
  beforeDestroy() {
    window.removeEventListener('hashchange', this.onHashChange);
  },
};
</script>

<style lang="scss" scoped>
  @import "./PurchaseHistory";
</style>
